import React from 'react';
import NavBar from "../../components/Navbar/NavBar";
import FooterOne from "../../components/Footer/Footer";
import { Box, Container, Grid, Paper, Typography, Button, useMediaQuery, useTheme } from '@mui/material';
import { libraryImages } from '../../utils/BeadsData';
import { useNavigate } from 'react-router-dom';

const LibraryDevelopment = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isMediumScreen = useMediaQuery(theme.breakpoints.between('sm', 'md'));

    const navigate = useNavigate();

    // Adjust grid columns based on screen size
    const getGridColumns = () => {
        if (isMobile) return 12;
        if (isMediumScreen) return 6;
        return 4; // Default to 4 for larger screens, for 3 items per row
    };

    return (
        <Box>
            <NavBar />
            <Container maxWidth="lg" sx={{ my: 12 }}>
                <Typography variant="h3" component="h1" gutterBottom align="center" my={5}>
                    Library Development
                </Typography>
                <Typography variant="body1" gutterBottom align="center" sx={{ mb: 4 }}>
                    Since 2005, BEADS has helped found three libraries at our schools in Kenya. Providing a constant flow of new library books to our schools is one of BEADS' top priorities.
                </Typography>
                <Grid container spacing={4}>
                    {libraryImages.map((img, index) => (
                        <Grid item xs={12} sm={getGridColumns()} md={getGridColumns()} key={index}>
                            <Paper elevation={3} sx={{
                                position: 'relative',
                                overflow: 'hidden',
                                borderRadius: '1rem',
                                '&:hover img': {
                                    transform: 'scale(1.1)',
                                },
                                img: {
                                    transition: 'transform 0.5s ease-in-out',
                                    width: '100%',
                                    height: isMobile ? 220 : 270,
                                    objectFit: 'cover',
                                },
                                '.image-caption': {
                                    position: 'absolute',
                                    bottom: 0,
                                    width: '100%',
                                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                    color: 'white',
                                    textAlign: 'center',
                                    padding: '8px',
                                }
                            }}>
                                <img src={img.src} alt={img.alt} loading='lazy' />
                                <Typography className="image-caption" variant="caption" display="block">
                                    {img.caption}
                                </Typography>
                            </Paper>
                        </Grid>
                    ))}
                </Grid>

                <Box sx={{ my: 4, textAlign: 'center' }}>
                    <Typography variant="h6" gutterBottom sx={{ fontStyle: 'italic' }}>
                        “When I go to the BEADS libraries, I can go anywhere in the world. After we read Helen Keller’s story, we ALL knew that we could do anything we were determined to do, and that nothing is impossible.”
                    </Typography>
                    <Typography variant="body2" sx={{ mt: 2 }}>
                        — BEADS Teaching Intern Rachael Undisha
                    </Typography>
                </Box>

                <Box sx={{ my: 5, textAlign: 'center' }}>
                    <Typography variant="body1" gutterBottom>
                        HELP OUR LIBRARY PROJECTS BY MAKING A DONATION.
                    </Typography>

                    <Button className='btn btn-border-base' variant="contained" onClick={() => navigate('/donate')}
                        sx={{
                            mt: 2,
                            borderRadius: 20,
                            // '&:hover': { transform: 'scale(1.05)' }
                        }}
                    >
                        DONATE
                    </Button>
                </Box>
            </Container>
            <FooterOne />
        </Box>
    );
}

export default LibraryDevelopment;